import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { easing } from 'ngx-slimscroll';
import { AlertPromise } from 'selenium-webdriver';
import { BrandDTO, CategoryDTO, CollectionDTO, dropdown, ImageDTO, Image1DTO, ProductsDTO, SubCategoryDTO, TagDTO } from 'src/app/shared/models/model';
import { brandService } from 'src/app/shared/service/brand.service';
import { CategoryService } from 'src/app/shared/service/category.service';
import { collectionService } from 'src/app/shared/service/collection.service';
import { subcategoryService } from 'src/app/shared/service/subcategory.service';
import { productService } from 'src/app/shared/service/product.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { tagService } from 'src/app/shared/service/tag.service';
import { LocalDataSource } from 'ng2-smart-table';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.scss']
})
export class AddProductComponent implements OnInit {

  public editorValue: string = '';
  public editorValuefr: string = '';
  public editorValuees: string = '';
  public Source: LocalDataSource;
  public countryForm: FormGroup;
  public subcategoryForm: FormGroup;
  public closeResult: string;
  public categoryList: CategoryDTO[] = [];
  public subcategoryList: SubCategoryDTO[] = [];
  public collectionList: CollectionDTO[] = [];
  public brandList: BrandDTO[] = [];
  public tagList: TagDTO[] = [];
  public productsList: ProductsDTO[] = [];
  public productDTO: ProductsDTO;
  public subcategoryDTO: SubCategoryDTO[];
  public subcategoryobject: SubCategoryDTO;
  public productobject: ProductsDTO;
  public productForm: FormGroup;
  public counter: number = 1;
  public subcategoriesVisible: boolean;
  public img: ImageDTO;
  public a: any;
  public ImageArray: Image1DTO[] = [];
  public Image1 = new Image1DTO();
  public formData: FormData = new FormData();
  public formDataArray: FormData[] = [];
  public dropDownTag: dropdown[] = [];
  public dropDownBrand: dropdown[] = [];
  public dropDownCollection: dropdown[] = [];
  public dropDownSubcategory: dropdown[] = [];
  public dropDownCategory: dropdown[] = [];
  public dropDownSale: dropdown[] = [];
  public dropDown: dropdown[] = [];
  public fileReader: FileReader = new FileReader();
  private formSubscription: Subscription;


  public url = [{
    img: "assets/images/user.png",
    del: ""
  },
  {
    img: "assets/images/user.png",
    del: ""
  },
  {
    img: "assets/images/user.png",
    del: ""
  },
  {
    img: "assets/images/user.png",
    del: ""
  },
  {
    img: "assets/images/user.png",
    del: ""
  }
  ];






  public settings = {
    "mode": "inline",
    selectMode: "multi",
    delete: {
      "confirmDelete": "true"
    },
    edit: { "confirmSave": "true" },
    actions: {
      position: 'right',
      update: true,
    },
    columns: {
      title: {
        title: 'titre'
      },
      codeProduct: {
        title: 'Code Product'
      },
      categoryIdcategoryNavigation: {
        title: 'category',
        valuePrepareFunction: (cell, row) => {
          return row.categoryIdcategoryNavigation.description;
        },
        editor: {
          type: 'list',
          config: {
            selectText: 'Select',
            list: this.dropDownCategory,
          },
          editable: true,
        }
      },
      subCategoryIdsubcategoryNavigation: {
        title: 'Sub Category',
        valuePrepareFunction: (cell, row) => {
          return row.subCategoryIdsubcategoryNavigation?.description;
        },
        editor: {
          type: 'list',
          config: {
            selectText: 'Select',
            list: this.dropDownSubcategory,
          },
          editable: true,
        }
      },
      description: {
        title: 'description'
      },
      brandIdbrandNavigation: {
        title: 'brand',
        valuePrepareFunction: (cell, row) => {
          return row.brandIdbrandNavigation.brand1;
        },
        editor: {
          type: 'list',
          config: {
            selectText: 'Select',
            list: this.dropDownBrand,
          },
          editable: true,
        }
      },
      tag: {
        title: 'tag',
      },
      sale: {
        title: 'sale',
        valuePrepareFunction: (cell, row) => {
          return row.sale == 1 ? "Yes" : "No";
        },
        editor: {
          type: 'list',
          config: {
            selectText: 'Select',
            list: this.dropDownSale,
          },
          editable: true,
        }
      },
      HasColor: {
        title: 'isproducthascolor',
        valuePrepareFunction: (cell, row) => {
          return row.isproducthascolor == 1 ? "Yes" : "No";
        },
        editor: {
          type: 'list',
          config: {
            selectText: 'Select',
            list: this.dropDownSale,
          },
          editable: true,
        }
      },
      Variant: {
        title: 'variant',
        type: 'html',
        valuePrepareFunction: (cell, row) => {
          var id = row.codeProduct;
          return `<a href="products/physical/add-variant/${id}">
          <img src="assets/images/user.png" alt="Add Variant" />
          </a>` ;
        }
      },
    }
  };


  constructor(private modalService: NgbModal, private fb: FormBuilder, private brand: brandService, private category: CategoryService, private collection: collectionService, private subcategory: subcategoryService, private tag: tagService, private product: productService) {
    debugger

    this.img = new ImageDTO();
    this.productForm = this.fb.group({
      title: ['', Validators.required],
      title_fr: ['', Validators.required],
      title_es: ['', Validators.required],
      category: [null, Validators.required],  // This should be required
      subcategory: [null], // Add this line - this was missing
      description: [null, Validators.required],
      description_fr: [null, Validators.required],
      description_es: [null, Validators.required],
      codeproduct: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9\\-]+')]],
      brand: ['', Validators.required],
      tag: [''],
      sale: [false],
      isproducthascolor: [false]
    });



    this.Source = new LocalDataSource();
    this.productobject = new ProductsDTO();
    this.categoryList = new Array<CategoryDTO>();
    this.dropDownSale.push(
      {
        title: "Yes",
        value: 1,
      },
      {
        title: "No",
        value: 0,
      },
    );



    this.category.getAllCategories().subscribe(data => {
      this.categoryList = [
        ...data.filter(item => item.description !== "") // Others
      ];

      //      // Optional: Reset control after load
      // this.productForm.controls['category'].reset();
      var dropDown = new dropdown();
      this.categoryList.forEach(element => {
        console.log(element);

        dropDown.value = element.idcategory;
        dropDown.title = element.description;
        console.log(dropDown.value);
        console.log(dropDown.title);
        this.dropDownCategory.push(
          {
            title: dropDown.title,
            value: dropDown.value,
          }
        )
      })
      var c = new CategoryDTO();
      c.description = "";
      c.idcategory = -1;
      // Explicitly set the form control to null
      this.productForm.controls['category'].setValue(c, { emitEvent: false });
      this.settings = Object.assign({}, this.settings);

    });

    this.subcategory.getSubcategories().subscribe(data => {

      this.subcategoryList = data;
      console.log(this.subcategoryList);
      var dropDown = new dropdown();
      this.dropDownSubcategory.push(
        {
          title: "",
          value: -1,
        }
      )
      this.subcategoryList.forEach(element => {
        console.log(element);

        dropDown.value = element.idsubcategory;
        dropDown.title = element.description;
        console.log(dropDown.value);
        console.log(dropDown.title);
        this.dropDownSubcategory.push(
          {
            title: dropDown.title,
            value: dropDown.value,
          }
        )
      })
      this.settings = Object.assign({}, this.settings);
    });




    this.productForm.patchValue({
      category: this.categoryList,
    });

    this.collection.getCollections().subscribe(data => {
      this.collectionList = data;

      console.log("collection");

      console.log(data);
      var dropDown = new dropdown();
      var collection = new CollectionDTO();
      collection.idcollection = -1;
      collection.description = "";
      // Explicitly set the form control to null
      this.productForm.controls['collections'].setValue(collection, { emitEvent: false });

      this.collectionList.forEach(element => {
        dropDown.value = element.idcollection;

        dropDown.title = element.description;

        console.log(dropDown.value);
        console.log(dropDown.title);
        this.dropDownCollection.push(
          {
            title: dropDown.title,
            value: dropDown.value,
          }
        )
        console.log(this.dropDownCollection);
      })
      this.settings = Object.assign({}, this.settings);
    });

    this.productForm.patchValue({
      collections: this.collectionList,
    });


    this.brand.getBrands().subscribe(data => {
      this.brandList = data;
      console.log(this.brandList);
      var dropDown = new dropdown();

      var brand = new BrandDTO();
      brand.idbrand = -1;
      brand.brand1 = "";
      // Explicitly set the form control to null
      this.productForm.controls['brand'].setValue(brand, { emitEvent: false });

      this.brandList.forEach(element => {
        console.log(element);


        dropDown.value = element.idbrand;
        dropDown.title = element.brand1;

        console.log(dropDown.value);
        console.log(dropDown.title);
        this.dropDownBrand.push(
          {
            title: dropDown.title,
            value: dropDown.value,
          }
        )
      })
      this.settings = Object.assign({}, this.settings);
    });


    this.productForm.patchValue({
      brand: this.brandList,
    });



    this.tag.getTags().subscribe(data => {
      this.tagList = data;
      console.log("tag");
      var dropDown = new dropdown();
      this.tagList.forEach(element => {
        console.log(element);
        dropDown.value = element.idtag;
        dropDown.title = element.tag1;
        console.log("tag");
        console.log(dropDown.value);
        console.log(dropDown.title);
        this.dropDownTag.push(
          {
            title: dropDown.title,
            value: dropDown.value,
          }
        )
      })
      this.settings = Object.assign({}, this.settings);

    });

    this.productForm.patchValue({
      tag: this.brandList,
    });

    this.getAllProducts()
  }

  getAllProducts() {

    this.product.getAllProducts().subscribe(data => {
      this.productsList = data;
      console.log("product",this.productsList);
      this.Source.load(Object.assign([], this.productsList)); // Refresh data
      this.Source.refresh();
    });

  }
  increment() {
    this.counter += 1;
  }

  decrement() {
    this.counter -= 1;
  }

  saveProduct(productForm) {
    debugger
    console.log("saving...");
    console.log(productForm);
    this.productDTO = new ProductsDTO();
    this.productDTO.Title = this.productForm.controls["title"].value;
    this.productDTO.Fr_Title = this.productForm.controls["title_fr"].value;
    this.productDTO.Es_Title = this.productForm.controls["title_es"].value;

    this.productDTO.IsProductHasColor = this.productForm.controls["isproducthascolor"].value;
   

    ///
    this.productDTO.CodeProduct = this.productForm.controls["codeproduct"].value;
    this.productDTO.BrandIdbrandNavigation = new BrandDTO;
    this.productDTO.BrandIdbrandNavigation = this.productForm.controls["brand"].value;


    if (this.productDTO.BrandIdbrandNavigation.brand1 == "") {
      this.productForm.get('brand').setErrors({ brandForbidden: true });

    }


    this.productDTO.BrandIdbrand = this.productDTO.BrandIdbrandNavigation.idbrand;
    this.productDTO.CategoryIdcategoryNavigation = new CategoryDTO;
    this.productDTO.CategoryIdcategoryNavigation = this.productForm.controls["category"].value;
    if (this.productDTO.CategoryIdcategoryNavigation.description == "") {
      this.productForm.get('category').setErrors({ testCategoryForbidden: true });

    }
    this.productDTO.CategoryIdcategory = this.productDTO.CategoryIdcategoryNavigation.idcategory;
  
    if(Array.isArray(this.productForm.controls["tag"].value)){
      this.productDTO.Tag="";
    }
    if (this.subcategoriesVisible == true) {
      this.productDTO.SubCategoryIdsubcategoryNavigation = new SubCategoryDTO();
      this.productDTO.SubCategoryIdsubcategoryNavigation = this.productForm.controls["subcategory"].value;
      if (this.productDTO.SubCategoryIdsubcategoryNavigation.description == "") {
        this.productForm.get('subcategory').setErrors({ subcategoryForbidden: true });
      }
    } else {
      this.productDTO.SubCategoryIdsubcategoryNavigation = new SubCategoryDTO();
      this.productDTO.SubCategoryIdsubcategoryNavigation.description = "";
    }
    this.productDTO.Description = this.productForm.controls["description"].value;
    this.productDTO.Fr_Description = this.productForm.controls["description_fr"].value;
    this.productDTO.Es_Description = this.productForm.controls["description_es"].value;

    const parser = new DOMParser();
    const doc = parser.parseFromString(this.productDTO.Description, 'text/html');
    const docfr = parser.parseFromString(this.productDTO.Fr_Description, 'text/html');
    const doces = parser.parseFromString(this.productDTO.Es_Description, 'text/html');


    //

    
    const bodyContent = doc.body.innerHTML.trim();
    const bodyContentfr = docfr.body.innerHTML.trim();
    const bodyContentes = doces.body.innerHTML.trim();

    if (!bodyContent) {
      this.productForm.get('description').setErrors({ descriptionforbidden: true });
    }

    if (!bodyContentfr) {
      this.productForm.get('description_fr').setErrors({ descriptionforbidden: true });
    }
    if (!bodyContentes) {
      this.productForm.get('description_es').setErrors({ descriptionforbidden: true });
    }

    if (this.productForm.controls["sale"].value == false) {
      this.productDTO.Sale = false;
    } else {
      this.productDTO.Sale = true;
    }
    this.productDTO.ImageDTOs = this.ImageArray;

    console.log("img:");
    console.log(this.productDTO);

    console.log("all products");
    console.log(this.Source);
    // window.location.reload();
    // productForm.confirm.resolve(productForm.newData);
    if (this.productForm.invalid) {
      console.log("Form is invalid. Submission stopped.");
      console.log("cat error", this.productForm.controls['category'].invalid);
      console.log("cat error", this.productForm.controls['category'].value);

      for (const controlName in this.productForm.controls) {
        const control = this.productForm.get(controlName);
        if (control && control.invalid) {
          console.log(`Control '${controlName}' is invalid. Errors:`, control.errors);
        }
      }

      return; // Prevent further processing
    }
    const newRow = {
      codeProduct: this.productDTO.CodeProduct,
      title: this.productDTO.Title,
      categoryIdcategoryNavigation: { description: this.productDTO.CategoryIdcategoryNavigation.description },
      subCategoryIdsubcategoryNavigation: { description: this.productDTO.SubCategoryIdsubcategoryNavigation.description },
      brandIdbrandNavigation: { brand1: this.productDTO.BrandIdbrandNavigation.brand1 },
      tag: this.productDTO.Tag,
      sale: this.productDTO.Sale,
      description: this.productDTO.Description
    };
    this.productDTO.CategoryIdcategoryNavigation = null;
    this.productDTO.CollectionIdcollectionNavigation = null;
    this.productDTO.SubCategoryIdsubcategoryNavigation = null;
    this.productDTO.BrandIdbrandNavigation = null;
    this.product.addProduct(this.productDTO);
    // Add the new row to the table source
    this.Source.add(newRow);
    // Refresh the table to reflect changes


    this.Source.refresh();
  }
  getCategories() {
    debugger
    var categoryId = this.productForm.controls['category'].value;
    this.subcategory.getSubCategory(categoryId["idcategory"]).subscribe(data => {
      this.subcategoryList = data;
      this.checkSubcategories(this.subcategoryList);
      console.log(this.subcategoryList);
    });
    this.productForm.patchValue({
      subcategory: this.subcategoryList,
    });
  }
  checkSubcategories(subcategories: any) {
    debugger
    if (subcategories.length == 0) {
      this.subcategoriesVisible = false;
      this.subcategoryobject = new SubCategoryDTO();
      this.subcategoryList.push(this.subcategoryobject);
      console.log("subcategories ", this.subcategoryList);
    } else {
      this.subcategoriesVisible = true;
      this.subcategoryobject = new SubCategoryDTO();
      this.subcategoryobject.description = "";
      this.subcategoryobject.idsubcategory = -1;
      // Explicitly set the form control to null
      this.productForm.controls['subcategory'].setValue(this.subcategoryobject, { emitEvent: false });
    }
  }

  open(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  deleteRecord(event) {
    var idProduct = event.data.codeProduct;
    this.product.deleteProduct(idProduct);
    event.confirm.resolve(event.newData);
  }

  updateRecord(event) {
    event.confirm.resolve(event.newData);
    debugger
    console.log("update record");
    console.log(event.newData);

    this.productDTO = new ProductsDTO();
    this.productDTO.Title = event.newData.title;
    this.productDTO.CodeProduct=event.newData.codeProduct;
    this.productDTO.Description = event.newData.description;
    this.productDTO.Idproduct = event.newData.idproduct;
    this.productDTO.Sale = event.newData.sale;

    this.productDTO.CategoryIdcategory = event.newData.categoryIdcategoryNavigation.idcategory == undefined ? Number(event.newData.categoryIdcategoryNavigation) : event.newData.categoryIdcategory;

    if (event.newData.subCategoryIdsubcategoryNavigation == null || event.newData.subCategoryIdsubcategoryNavigation == -1) {
      this.productDTO.SubCategoryIdsubcategory = null;
    }

    else {

      this.productDTO.SubCategoryIdsubcategory = event.newData.subCategoryIdsubcategoryNavigation.idsubcategory == undefined ? Number(event.newData.subCategoryIdsubcategoryNavigation) : event.newData.subCategoryIdsubcategoryNavigation.idsubcategory;

    }

    this.productDTO.BrandIdbrand = event.newData.brandIdbrandNavigation.idbrand == undefined ? Number(event.newData.brandIdbrandNavigation) : event.newData.brandIdbrand;

    // this.productDTO.TagIdtag = event.newData.tagIdtagNavigation.idtag == undefined ? Number(event.newData.tagIdtagNavigation) : event.newData.tagIdtag;

    this.productDTO.CollectionIdcollection = event.newData.collectionIdcollectionNavigation.idcollection == undefined ? Number(event.newData.collectionIdcollectionNavigation) : event.newData.collectionIdcollection;



    this.product.updateProduct(this.productDTO);


    event.confirm.resolve();
    window.location.reload();

  }

  fillDropdown(list: any, dropdownlist: dropdown[]) {

    list.forEach(element => {
      console.log(element);

      var dropDown = new dropdown();
      dropDown.value = element.idcategory;
      dropDown.title = element.description;
      console.log(dropDown.value);
      console.log(dropDown.title);
      dropdownlist.push(
        {

          title: dropDown.title,
          value: dropDown.value,
        }
      );


      this.settings = Object.assign({}, this.settings);
    });
  }



  //FileUpload
  readUrl(event: any, i) {
    debugger
    if (event.target.files.length === 0)
      return;
    //Image upload validation
    var mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    // Image upload
    var reader = new FileReader();
    this.Image1 = new Image1DTO();
    reader.readAsDataURL(event.target.files[0]);
    this.readFile(event.target.files[0]);

    reader.onload = (_event) => {
      this.url[i].img = reader.result.toString();
      this.url[i].del = "assets/images/delete.png";
      event.target.value = "";
    }
  }
  deletImg(event: any, i) {
    debugger
    this.url[i].img = "assets/images/user.png";
    this.url[i].del = null;
    console.log(event);
    this.ImageArray.splice(i);
    event.target.value = "";

  }

  readFile(file: File) {
    const reader = new FileReader();
    reader.onload = () => {
      const dataURL: string | ArrayBuffer | null = reader.result;
      if (typeof dataURL === 'string') {
        // Extract base64 string from data URL
        const base64String = this.extractBase64FromDataURL(dataURL);
        this.Image1.name = file.name;
        this.Image1.blobValue = base64String;
        console.log("img inserted");
        console.log(this.Image1);
        this.ImageArray.push(this.Image1);
      }
    };
    reader.readAsDataURL(file);
  }

  extractBase64FromDataURL(dataURL: string): string {
    return dataURL.split(',')[1];
  }

  ngOnInit() {


    // Check if there's data in sessionStorage and pre-populate the form
    const storedData = sessionStorage.getItem('formData');
    if (storedData) {
      const formData = JSON.parse(storedData);
      this.productForm.patchValue(formData);
    }




  }

}
